import { controls, grouped } from "../../controls";

const apexpendency = {
  label: "Quarterly Pendency",
  starting: true,
  url: "apexpendency",
  pageLabel: "Quarterly Pendency",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.magicDateLabel({ tab: "filter", label: "As On Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", default: "lqe" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Quarterly Pendency",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    textReportProps: {
      'Recon': {
        filename: `Quarterly Pendency-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Report Name",
        accessor: "report_display",
        rwidth: "*"
      },
      {
        Header: "Ambala",
        accessor: "ambala",
        type: "tick"
      },
      {
        Header: "Bhiwani",
        accessor: "bhiwani",
        type: "tick"

      },
      {
        Header: "F/Bad",
        accessor: "fbar",
        type: "tick"
      },
      {
        Header: "Ft/Bad",
        accessor: "ftbad",
        type: "tick"
      },
      {
        Header: "Gurgaon",
        accessor: "gurugaon",
        type: "tick"
      },
      {
        Header: "Hisar",
        accessor: "hisar",
        type: "tick"
      },
      {
        Header: "Jhajjar",
        accessor: "jhajjar",
        type: "tick"
      },
      {
        Header: "Jind",
        accessor: "jind",
        type: "tick"
      },
      {
        Header: "Karnal ",
        accessor: "karnal",
        type: "tick"
      },
      {
        Header: "Kaithal",
        accessor: "kaithal",
        type: "tick"
      },
      {
        Header: "K/shetra",
        accessor: "kshetra",
        type: "tick"
      },
      {
        Header: "M/garh",
        accessor: "mgarh",
        type: "tick"
      },
      {
        Header: "Panipat",
        accessor: "panipat",
        type: "tick"
      },
      {
        Header: "Rewari",
        accessor: "rewari",
        type: "tick"
      },
      {
        Header: "Rohtak",
        accessor: "rohtak",
        type: "tick"
      },
      {
        Header: "Sirsa",
        accessor: "sirsa",
        type: "tick"
      },
      {
        Header: "Sonepat",
        accessor: "sonepat",
        type: "tick"
      },
      {
        Header: "Y/nagar",
        accessor: "ynagar",
        type: "tick"
      },
      {
        Header: "P/kula",
        accessor: "pkula",
        type: "tick"
      }
    ]
  }
};

export default apexpendency;